// LICENSE_CODE ZON
'use strict'; /*jslint browser:true, es6:true, node:true, react:true*/
import React, {useContext, Fragment, useEffect} from 'react';
import {useHistory} from 'react-router';
import cn from 'classnames';
import {Settings_context} from '../../../../hola/pub/settings_ctx';
import styles from './proxy-location.module.less';
import {Button} from '../../../../hola/pub/lib/button';
import {use_pathname} from '../../../../hola/pub/lib/use_pathname';
import {Flag} from '../../../../hola/pub/lib/flag';
import Arrow_right from '../../../../hola/pub/img/hola2023/icons/24/arrow_right.svg';
import country from '/util/country.js';
import {Faq_section} from '../../ui/toolip/faq_section';
import {Map} from '../../ui/landings/map';
import {bd_countries} from 'hola_opt';
import {t_country_object} from '../../types';
import anim_styles from '../../ui/animation.module.less';
import {Lottie} from '../../../../hola/pub/lib/lottie';
import {toolip_img_url} from '../../../../hola/pub/ui/toolip_img_url';
import {HP_cards} from '../../ui/hp_cards';
import {Products_cards} from '../../ui/free_proxy/product_cards';
import {Use_case_bubbles} from '../../ui/use_case_bubbles';
import {Review_slides} from '../../ui/landings/review_slides';
import {use_screen} from '../../../../hola/pub/lib/screen_util';
import {use_translation_v} from '../../../../hola/pub/lib/trans_v';
import {perr_www_visit} from 'hola_pub_util';
import {use_show_promo} from '../../ui/free_proxy/use_show_promo';

const find_country_by_name = (name: string): t_country_object | null=>{
    const normalized_name = name.replace(/-/g, ' ').toUpperCase().trim();
    const c = Object.entries(country.list).find(([key, val])=>{
        return key == normalized_name ||
            (val as string).toUpperCase() == normalized_name;
    });
    return c ? country.get_country_object(c[0]) : null;
};

const continents = ['europe', 'north-america', 'latin-america', 'asia',
    'africa', 'oceania'];

const flags = [
    {country: 'br', title: 'Brazil'},
    {country: 'gb', title: 'United Kingdom'},
    {country: 'de', title: 'Germany'},
    {country: 'fr', title: 'France'},
    {country: 'ca', title: 'Canada'},
    {country: 'us', title: 'United States'},
    {country: 'jp', title: 'Japan'},
    {country: 'au', title: 'Australia'},
];

const is_continent = name=>continents.includes(name.toLowerCase());

const get_adjective_form = continent_name=>{
    const forms = {
        'europe': 'European',
        'north america': 'North American',
        'latin america': 'Latin American',
        'asia': 'Asian',
        'africa': 'African',
        'oceania': 'Oceanian'
    };
    const continent_mapping = {
        'europe': 'Europe',
        'north america': 'Northern America',
        'latin america': 'LATAM',
        'asia': 'Asia',
        'africa': 'Africa',
        'oceania': 'Oceania'
    };
    return {
        adjective: forms[continent_name.toLowerCase()] || continent_name,
        key: continent_mapping[continent_name.toLowerCase()] ||
            continent_name.replace(/\b\w/g, c=>c.toUpperCase())
    };
};

const get_region_countries = region=>{
    const excluded_ountries = ['ps'];
    const countries = bd_countries.by_region[region]?.countries || [];
    return countries.filter(ctr=>!excluded_ountries.includes(ctr));
};

const get_flag_country_code = country_code=>{
    const french_territories = {
      'gp': 'fr', // Guadeloupe
      'bl': 'fr', // Saint Barthelemy
      'mf': 'fr', // Saint Martin
      're': 'fr', // Réunion
      'yt': 'fr', // Mayotte
      'wf': 'fr', // Wallis And Futuna Islands
    };
    return french_territories[country_code?.toLowerCase()] || country_code;
};

export const prepare_continent_data = ()=>{
    return continents.map(continent=>{
        const continent_name = continent.replace(/-/g, ' ');
        const {key} = get_adjective_form(continent_name);
        return {
            quest: continent_name.replace(/\b\w/g, l=>l.toUpperCase()),
            ans: get_region_countries(key)
                .map(country_code=>{
                    const country_name =
                        country.list[country_code.toUpperCase()];
                    return {
                        name: country_name,
                        url: `/proxy-location/${country_name.toLowerCase()
                            .replace(/\s+/g, '-')}`
                    };
                })
        };
    });
};

export const Top_locations = ({lp_mode=false, location_name='',
    is_continent_page=false, continent_key=''})=>{
    const {theme} = useContext(Settings_context);
    const history = useHistory();
    const {T} = use_translation_v({no_defaults: true});
    const location_title = is_continent_page ?
        `${location_name?.replace(/-/g, ' ')
            .replace(/\b\w/g, l=>l.toUpperCase())} proxy locations`
        : 'Top locations';
    const get_country_url = _title=>{
        let country_param = _title.toLowerCase().replace(' ', '-');
        if (_title == 'United Kingdom')
            country_param = 'great-britain';
        history.push(`/proxy-location/${country_param}`);
        window.scrollTo({top: 0, behavior: 'smooth'});
    };
    const location_countries = lp_mode ? flags :
        is_continent_page ? get_region_countries(continent_key) : flags;
    return <div className={styles.top_locations}>
      <div className={styles.locations_text}>
        <h2 className={theme.color_n700}><T>{location_title}</T></h2>
          <div className={styles.flags}>
            {location_countries.map(f=>{
              const _country_code = lp_mode ? f.country :
                is_continent_page ? f : f.country;
              const country_name = lp_mode ? f.title : is_continent_page ?
                country.list[_country_code.toUpperCase()] : f.title;
              const flag_code = get_flag_country_code(_country_code);
              return <div
                key={is_continent_page ? f : f.country}
                className={styles.country_ip}
                onClick={e=>{
                  e.preventDefault();
                  get_country_url(country_name);
                }}
              >
                <div className={styles.line_with_flag}>
                  <Flag
                    round
                    country={flag_code}
                    size={18}
                  />
                  <p className={cn(
                    theme.p3,
                    theme.color_n800,
                    theme.med,
                    styles.country_name
                  )}>
                    {country_name}
                  </p>
                </div>
              </div>;
            })}
          </div>
    </div>
  </div>;
};

export const Root = ()=>{
    const {theme} = useContext(Settings_context);
    const {T, t} = use_translation_v({no_defaults: true});
    const {set, params} = use_pathname();
    const {width} = use_screen();
    const {show_promo, get_cta} = use_show_promo();
    const location_name = params['proxy-location'];
    const us_region_name = params['united-states'];
    const detected_location_name = !location_name && us_region_name
        ? 'united-states' : location_name;
    const is_lobby_page = !detected_location_name ||
        detected_location_name === '';
    const is_continent_page = !is_lobby_page &&
        is_continent(detected_location_name);
    const is_us_region = !location_name && !!us_region_name;
    const caption = show_promo ? 'Try now for free' : 'Try now';
    useEffect(()=>{
        if (location_name?.length == 2)
        {
            const normalized_name = location_name.toUpperCase();
            const c = Object.entries(country.list).find(([key])=>
                key == normalized_name);
            if (c && typeof c[1] == 'string')
            {
                const country_param = c[1] == 'United Kingdom' ?
                    'great-britain' : c[1].toLowerCase().replace(/\s+/g, '-');
                set({
                    'proxy-location': country_param
                });
            }
        }
    }, [location_name, set]);
    useEffect(()=>{
        perr_www_visit({id: 'toolip_proxy_location_visit'});
    }, []);
    let country_code, ip_count, title, subtitle, continent_key;
    if (is_lobby_page)
    {
        title = t('Choose from truly worldwide proxies');
        subtitle = `Take advantage of toolip's extensive proxy server IPs to
            bypass geo-restrictions and access global public web data.`;
        country_code = null;
    }
    else if (is_continent_page)
    {
        const continent_name = location_name.replace(/-/g, ' ');
        const {adjective: continent_adjective, key: continent_key_temp} =
            get_adjective_form(continent_name);
        continent_key = continent_key_temp;
        ip_count = bd_countries.by_region[continent_key]?.count || 0;
        title = width > 950 ? <>
          {ip_count.toLocaleString()} {continent_adjective} <T>Proxies</T>
        </> : <>
          {ip_count.toLocaleString()}<br/>{continent_adjective} <T>Proxies</T>
        </>;
        subtitle = `Access any ${continent_name.charAt(0).toUpperCase() +
            continent_name.slice(1)} website and achieve your goals with ISP
            proxies or datacenters. No barriers & total anonymity!`;
    }
    else
    {
        const country_obj = find_country_by_name(detected_location_name);
        if (!country_obj)
            return <div>/choose Location</div>;
        country_code = country_obj.code == 'uk' ? 'gb' : country_obj.code;
        ip_count = bd_countries && bd_countries[country_code] || 0;
        const region_display_name = us_region_name
            ? us_region_name.replace(/\b\w/g, l=>l.toUpperCase())
            : country_obj.name;
        title = width > 950
            ? <>{ip_count.toLocaleString()} {region_display_name} <T>Proxies</T></>
            : <>{ip_count.toLocaleString()}{region_display_name} <T>Proxies</T></>;
        subtitle = `Access any ${region_display_name} website and
            achieve your goals with ISP proxies or datacenters.
            No barriers & total anonymity!`;
    }
    const map_countries = is_lobby_page ? [] :
        is_continent_page ?
            get_region_countries(continent_key) : [country_code];
    return <div>
        <section className={styles.hero_section}>
          <div className={cn(styles.hero, theme.container)}>
            <div className={cn(styles.hero_top, anim_styles.hero_showup_1)}>
              <p className={cn(theme.mono14, styles.uptime)}>
                <Lottie autoplay loop width="20px" height="14px"
                  src={toolip_img_url('animation/uptime.json')}/>
                <span><T>Uptime: <b>99.9%</b></T></span>
              </p>
            </div>
            <div className={styles.hero_content}>
              <div className={cn(styles.hero_heading,
                anim_styles.hero_showup_2)}>
                {!is_continent_page && !is_lobby_page &&
                  <Flag country={get_flag_country_code(is_us_region ? 'us' :
                    country_code)} round size={40}/>}
                <h1 className={theme.H2}>{title}</h1>
              </div>
              <p className={cn(theme.u2, theme.med,
                theme.color_n600, anim_styles.hero_showup_2)}>
                  <T>{subtitle}</T>
              </p>
              <div className={cn(styles.mobile_info,
                anim_styles.hero_showup_3)}>
                <div className={styles.info_button}>
                  <Button size='lg' cls={styles.button}
                    caption={<>{caption}<Arrow_right/></>}
                    round={false} color='black' to='/dashboard' fit/>
                </div>
              </div>
              <p className={cn(theme.p12, theme.med,
                anim_styles.hero_showup_3)}>
                <T>Free proxies</T> | <T>No credit card required</T>
              </p>
            </div>
            <div className={cn(styles.hero_map, anim_styles.hero_showup_4)}>
              <Map key={country_code || location_name || 'lobby'}
                country_code={is_lobby_page ? null : country_code}
                countries={map_countries}/>
            </div>
          </div>
        </section>
        <Top_locations
          location_name={detected_location_name}
          is_continent_page={is_continent_page}
          continent_key={continent_key}
        />
        <HP_cards/>
        {!is_lobby_page && <Use_case_bubbles offset_top={-390}/>}
        <Products_cards
          title={'The toolip Products'}
          subtitle=
            {'Choose what best matches your needs and goals on the house!'}
          with_icons
          get_cta={get_cta}
          />
        {!is_lobby_page && <Review_slides/>}
        <div className={cn(styles.faq_block, theme.container)}>
          <Faq_section
            title={is_lobby_page
              ? 'When we say our proxies are global, we mean it.'
              : 'Some FAQs'}
            color={'transparent'}
            custom_questions={is_lobby_page
              ? prepare_continent_data()
              : undefined}
          />
        </div>
        <div className={styles.final}>
          <div className={styles.final_bg}/>
          <div className={styles.final_container}>
            <h2><T>Get the right Proxies</T>.<br/>
              <T>Get ahead</T>.</h2>
            <Button size={'lg'} no_jump cls={styles.final_btn}
              to={'/dashboard'} fit round={false}
              caption={<Fragment><T>{caption}</T> <Arrow_right/>
                </Fragment>}/>
          </div>
        </div>
    </div>;
};

const meta = {
      meta: props=>{
        const {translate = t=>t} = props;
        const param = props?.params?.['proxy-location'] || '';
        const us_region = props?.params?.['united-states'];
        const location = param || us_region || '';
        let title, description, canonical_url;
        if (!location)
        {
            title = translate('Real Proxy IP Servers in Any Location');
            description = translate('Uncover the advantages of real proxy ip '
                +'servers in any location.');
            canonical_url = 'https://toolip.io/proxy-location/';
        }
        else
        {
            const countryName = param.replace(/-/g, ' ')
                .replace(/\b\w/g, c=>c.toUpperCase());
            title = translate(`Premium ${countryName} Proxies - Try Now For
                Free | Toolip`);
            description = translate(`Unlock ${countryName} proxies with a
                free trial. Experience premium connectivity now.`);
            canonical_url = `https://toolip.io/proxy-location/${param}`;
        }
        return {title, description, canonical_url};
    },
    no_ssr: false,
    ssr_force: true,
    footer_opt: {
        gradient_color: 'var(--wp--preset--color--blue-100)',
    },
    translation: {
        enabled: true,
        detect_by_country: true,
        white_list: ['en', 'ru', 'es', 'tr', 'de', 'fr', 'ja', 'he', 'zh']
    },
};
Root.meta = meta;
